import { render, staticRenderFns } from "./ReductionPlan.vue?vue&type=template&id=f53e35a4"
import script from "./ReductionPlan.vue?vue&type=script&lang=js"
export * from "./ReductionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports